// variant used with TextField components - https://material-ui.com/components/text-fields
export enum TextFieldStyleVariant {
  Filled = 'filled',
  Outlined = 'outlined',
  Standard = 'standard',
}
